import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserUtils } from '@azure/msal-browser';

import { DashboardComponent } from './dashboard/dashboard/dashboard.component';
import { FailedComponent } from './login/failed/failed.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found/page-not-found.component';
import { ProfileComponent } from './profile/profile/profile.component';

const routes: Routes = [
  {
    path: 'profile',
    component: ProfileComponent
  },
  {
    path: '',
    component: DashboardComponent
  },
  {
    path: 'login-failed',
    component: FailedComponent
  },
  {
    path: 'comparisons',
    pathMatch: 'full',
    loadComponent: () => import('./optimisation-comparisons/optimisation-comparisons.component').then(m => m.OptimisationComparisonsComponent)
  },
  {
    path: 'mti-comparison',
    pathMatch: 'full',
    loadComponent: () => import('./mti-comparison/mti-comparison.component').then(m => m.MtiComparisonComponent)
  },
  {
    path: 'pnl-explain',
    pathMatch: 'full',
    loadComponent: () => import('./pnl-explain/pnl-explain.component').then(m => m.PnLExplainComponent)
  },
  {
    path: 'pnl-explain/mapping',
    pathMatch: 'full',
    loadComponent: () => import('./pnl-explain/mapping/pnl-explain-mapping.component').then(m => m.PnLExplainMappingComponent),
    canDeactivate: [(c: { dirty: boolean }) => !c.dirty || confirm('Leave without saving your mapping changes?')]
  },
  {
    path: 'gantt',
    pathMatch: 'full',
    loadComponent: () => import('./gantt/gantt.component').then(m => m.GanttComponent)
  },
  {
    path: 'gantt/mapping',
    pathMatch: 'full',
    loadComponent: () => import('./gantt/mapping/gantt-mapping.component').then(m => m.GanttMappingComponent),
    canDeactivate: [(c: { dirty: boolean }) => !c.dirty || confirm('Leave without saving your mapping changes?')]
  },
  {
    path: 'explorer',
    loadComponent: () => import('./berth-schedule/explorer-shell/explorer-shell.component').then(m => m.ExplorerShellComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'berth-schedule' },
      {
        path: 'berth-schedule',
        pathMatch: 'full',
        loadComponent: () => import('./berth-schedule/berth-schedule.component').then(m => m.BerthScheduleComponent)
      },
      {
        path: 'inventory/volume-groups',
        pathMatch: 'full',
        loadComponent: () => import('./berth-schedule/inventory-tab/inventory-tab.component').then(m => m.InventoryTabComponent),
        data: { kind: 'volume' }
      },
      {
        path: 'inventory/volume-new',
        pathMatch: 'full',
        loadComponent: () => import('./berth-schedule/volume-new-tab/volume-new-tab.component').then(m => m.VolumeNewTabComponent)
      },
      {
        path: 'inventory/tank-groups',
        pathMatch: 'full',
        loadComponent: () => import('./berth-schedule/inventory-tab/inventory-tab.component').then(m => m.InventoryTabComponent),
        data: { kind: 'tank' }
      },
      {
        path: 'map',
        pathMatch: 'full',
        loadComponent: () => import('./berth-schedule/map-tab/map-tab.component').then(m => m.MapTabComponent)
      },
      {
        path: 'specs',
        pathMatch: 'full',
        loadComponent: () => import('./berth-schedule/specs-tab/specs-tab.component').then(m => m.SpecsTabComponent)
      },
      {
        path: 'pl-compare',
        pathMatch: 'full',
        loadComponent: () => import('./berth-schedule/placeholder-tab/placeholder-tab.component').then(m => m.PlaceholderTabComponent),
        data: { title: 'PL Delta' }
      },
      {
        path: 'ledger',
        loadComponent: () => import('./berth-schedule/ledger/ledger-shell/ledger-shell.component').then(m => m.LedgerShellComponent),
        children: [
          { path: '', pathMatch: 'full', redirectTo: 'adp' },
          {
            path: 'adp',
            pathMatch: 'full',
            loadComponent: () => import('./berth-schedule/ledger/adp-tab/adp-tab.component').then(m => m.AdpTabComponent)
          },
          {
            path: 'comparison',
            pathMatch: 'full',
            loadComponent: () => import('./berth-schedule/ledger/comparison-tab/comparison-tab.component').then(m => m.ComparisonTabComponent)
          }
        ]
      },
      {
        path: 'comparison',
        pathMatch: 'full',
        loadComponent: () => import('./berth-schedule/run-comparison-tab/run-comparison-tab.component').then(m => m.RunComparisonTabComponent)
      }
    ]
  },
  { path: 'berth-schedule', pathMatch: 'full', redirectTo: 'explorer/berth-schedule' },
  { path: 'inventory/volume-groups', pathMatch: 'full', redirectTo: 'explorer/inventory/volume-groups' },
  { path: 'inventory/volume-new', pathMatch: 'full', redirectTo: 'explorer/inventory/volume-new' },
  { path: 'inventory/tank-groups', pathMatch: 'full', redirectTo: 'explorer/inventory/tank-groups' },
  { path: 'map', pathMatch: 'full', redirectTo: 'explorer/map' },
  {
    path: 'feasibility-checks',
    pathMatch: 'full',
    loadComponent: () => import('./feasibility-checks/feasibility-checks.component').then(m => m.FeasibilityChecksComponent)
  },
  // ADD ALL NEW PAGES ABOVE THIS 404 PAGE
  {
    path: '**',
    pathMatch: 'full',
    component: PageNotFoundComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // Don't perform initial navigation in iframes or popups
    initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled', // Set to enabledBlocking to use Angular Universal
    bindToComponentInputs: true
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
